import React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@omni/components/components/Account/Profile/ProfileAddressBook/profileAddressBook.container"
    ).then((module) => ({
        default: module.ProfileAddressBook
    }))
);
